import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';
import { ManagerPinProvider, RequireSession } from './session';
import LoginPage from './pages/Login';
import SellPage from './pages/Sell';
import OrdersPage from './pages/Orders';
import DrawerPage from './pages/Drawer';
import './styles.css';
import { loadTerms } from './terms';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, staleTime: 10_000, refetchOnWindowFocus: false } } });

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: (
      <RequireSession>
        <App />
      </RequireSession>
    ),
    children: [
      { index: true, element: <SellPage /> },
      { path: 'sell', element: <SellPage /> },
      { path: 'sell/:performanceId', element: <SellPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/:id', element: <OrdersPage /> },
      { path: 'drawer', element: <DrawerPage /> },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) throw new Error('No #root element');
// The deployment's words before the first screen (D-378), so no label flips
// from "Dates" to "Games" after it is drawn. Never waits more than a moment.
void loadTerms().finally(() => {
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ManagerPinProvider>
          <RouterProvider router={router} />
        </ManagerPinProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
});
